import React from 'react';
import { Mouvement } from '@mairistem/comptabilite';
import NumeroEmpruntComponent from '../../../components/Mouvement/Panel/NumeroEmpruntComponent';
import CODE_PANEL from '../../../constants/mouvements/codePanel';
import LignePanel from './LignePanel';

class NumeroEmpruntPanel extends LignePanel {
  constructor(isMandatory = false) {
    super(isMandatory);
    this.code = CODE_PANEL.NUMERO_EMPRUNT;
    this.icon = { name: 'eur' };
  }

  getLibelle = () => "Numéro d'emprunt";

  isEmpty = (data: Mouvement) => !data?.lignes?.find((ligne) => ligne?.emprunt);

  getComponent = function getComponent(
    data: any,
    onChange: any,
    handlePin: any,
  ): React.ReactElement {
    return (
      <NumeroEmpruntComponent
        data={data}
        handlePin={handlePin}
        onChange={onChange}
        panel={this}
      />
    );
  };
}

export default NumeroEmpruntPanel;
